import React, { Component } from "react";
import MovieThumbnailList from "../Components/MovieThumbnailList";
import MovieDetail from "../Components/MovieDetail";
import Spinner from "../Components/Spinner";
import Search from "../Components/Search";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as actions from "../store/actions";
import { API_KEY, API_URL } from "../config";
import CastList from "../Components/CastList";

class Content extends Component {
  render() {
    const {
      loading,
      searchTerm,
      isDetail,
      movieDetail,
      casts,
      showSideNav,
      changeSideNavState,
      trailerKey,
      recommendations,
      loadMore,
      search,
      isCastPage
    } = this.props;

    const renderList = () => {
      return (
        <div className="below">
          <h3 className="heading__secondary margin-bottom-medium">
            {this.getTitleOfThePage()}
          </h3>
          <MovieThumbnailList />
          {/* if it's a detail page hide load more in recommendations */}
          {isDetail ? (
            false
          ) : (
            <a
              href="#"
              className="btn btn__loadMoreBtn"
              onClick={this.onLoadMore}
            >
              Load More
            </a>
          )}
        </div>
      );
    };
    const renderCast = () => {
      return (
        <div className="below">
          <h3 className="heading__secondary margin-bottom-medium">
            {this.getTitleOfThePage()}
          </h3>
          <CastList />
          {/* if it's a detail page hide load more in recommendations */}
          {isDetail ? (
            false
          ) : (
            <a
              href="#"
              className="btn btn__loadMoreBtn"
              onClick={this.onLoadMoreCast}
            >
              Load More
            </a>
          )}
        </div>
      );
    };

    return (
      <main className="content">
        {loading ? <Spinner /> : false}
        <Search search={search} />
        <input
          type="checkbox"
          className="side-nav__checkbox"
          name="sidenav__checkbox"
          id="checkbox"
        />
        <label
          className="side-nav__toggle"
          for="checkbox"
          onClick={changeSideNavState}
        >
          <span className="line"></span>
        </label>
        {/* Movie Detail */}
        {isDetail && searchTerm === "" ? (
          <MovieDetail {...movieDetail} casts={casts} trailerKey={trailerKey} />
        ) : (
          false
        )}

        {isCastPage ? renderCast() : renderList()}
      </main>
    );
  }

  getTitleOfThePage = () => {
    const { pathname } = this.props.location;
    if (pathname === "/") {
      return "Popular Movies";
    } else if (pathname === "/trending") {
      return "Trending Movies";
    } else if (pathname.includes("/detail")) {
      return "Recommendations";
    } else if (pathname.includes("/category")) {
      // ["", "category", "Horror"]
      const splitted = pathname.split("/")[2];
      return `${splitted} Movies`;
    }
  };
  onLoadMore = e => {
    const { currentPage, loadMore, changeLoadingState } = this.props;
    e.preventDefault();
    let endpoint = `${API_URL}movie/popular?api_key=${API_KEY}&language=en-US&page=${currentPage +
      1}`;
    changeLoadingState();
    loadMore(endpoint);
  };

  onLoadMoreCast = e => {
    const { currentPage, loadMore, changeLoadingState } = this.props;
    e.preventDefault();
    let endpoint = `${API_URL}person/popular?api_key=${API_KEY}&language=en-US&page=${currentPage +
      1}`;
    changeLoadingState();
    loadMore(endpoint);
  };
}

const mapStateToProps = state => {
  return {
    currentPage: state.currentPage,
    totalPages: state.totalPages,
    loading: state.loading,
    isDetail: state.isDetail,
    movieDetail: state.movieDetail,
    trailerKey: state.trailerKey,
    searchTerm: state.searchTerm,
    movies: state.movies
  };
};

export default connect(mapStateToProps, actions)(withRouter(Content));

// Content.js

// MovieThumbnailList for normal route

// With /cast is CastList
// With /cast/Henry-cavill is a detail information section and a known for section(Reuse MovieThumbnailList change the input data)
